var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topNav',{attrs:{"title":"消息通知","border":true}}),_c('noneHint',{attrs:{"img":_vm.hintimg,"hint":"小可愛暫時無消息哦~~"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }